export const NavigationRoutes = {
    HOME: '/',
    VISUALIZE : '/visualize',
    VISUALIZEBYNAME : '/visualize/:name',
    MARKET_SNAPSHOT: '/market-snapshot',
    MARKET_SNAPSHOT_BY_NAME: '/market-snapshot/:name',
    VISUALIZE_DATA : '/VisualizeData',
    DOWNLOAD_DATA : '/DownloadData',
    REPORTS : '/Library',
    BROWSE_IDEAS: '/BrowseIdeas',
    METHODOLOGY: '/Methodology',
    PRIORITIZE_IDEAS: '/PrioritizeIdeas',
    RESEARCH_COMPANIES: '/ResearchCompanies',
    SUPPORT: {
        ROOT : "/Support",
        FAQs : "/Support/FAQs",
        FileName : "/Support/:fileName",
        METHODOLOGY : "/Support/Methodology",
        Product_Hierarchy : "/Support/Product_hierarchy"
    },
    PUBLICATIONS : {
        ROOT : "/Insights"
    },
    INSIGHTS : {
        ROOT : "/Insights"
    },
    SAVED_INSIGHTS: '/SavedInsights',
    DISCOVER_TRENDS: {
        ROOT: '/DiscoverTrends',
        INDUSTRY: '/DiscoverTrends/Industry',
        PRODUCT: '/DiscoverTrends/Product',
        PEER_ANALYSIS: '/DiscoverTrends/PeerAnalysis',
        ENTRY_STRATEGY: '/DiscoverTrends/EntryStrategy',
        TECHNOLOGY: '/DiscoverTrends/Technology',
        ECOSYSTEM_JOURNEY: '/DiscoverTrends/EcosystemJourney',
    }
}
